import { createContext } from 'react';

import { type DocyrusAuthContextValue } from '../types';

export const DocyrusAuthContext = createContext<DocyrusAuthContextValue | null>(null);
